import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as Truck } from 'images/truck.svg';
import WidgetContainer from 'components/widget/WidgetContainer';
import TextLink from './TextLink';

const WIDGET_TITLE = 'Have you recently moved?';

const Wrapper = styled(WidgetContainer)`
  >.card {
    display: flex;
  }

  .iconWrapper {
    flex-shrink:0;
    svg {
      width: 104px;
      height: auto;
    }
  }
  .contentWrapper {
    flex-grow: 1;
  }
`;

const JustMoved = ({ className, path }) => {
  const classes = ['JustMoved'];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(' ')}>
      <div className="contentWrapper">
        <h2>{WIDGET_TITLE}</h2>
        <TextLink
          rightChevron
          props={{ to: path }}
          dataLayer={{ action: 'Change Address Link Click', label: 'Change Address' }}
        >
          Change address
        </TextLink>
      </div>
      <div className="iconWrapper">
        <Truck />
      </div>
    </Wrapper>
  );
};

JustMoved.displayName = 'JustMoved';

JustMoved.propTypes = {
  className: PropTypes.string,
  path: PropTypes.string,
};

JustMoved.defaultProps = {
  className: null,
  path: null,
};

export default JustMoved;
